import ReloadableComponentPrototype from 'ReloadableComponentPrototype';
import $ from 'jquery';

export default class ImageHero extends ReloadableComponentPrototype {
  build() {
    if (this.data.hasMotion) {
      this.motionDone = false;
      this.addViewHandlers();
      this.handleViewEvents(); // For initial page load
    }
  }

  doMotion() {
    this.node.addClass('image-hero--motion');

    if (this.visibilityTimeout) {
      clearTimeout(this.visibilityTimeout);
    }
  }

  addViewHandlers() {
    $(window).on('scroll resize', () => {
      this.handleViewEvents();
    });
  }

  handleViewEvents() {
    // Instead of this, we could remove the handler to prevent the function being called every time a scroll or resize happens.
    if (!this.motionDone) {
      const isVisibleAtAll = this.isInViewport(this.node[0], 0.01);

      if (isVisibleAtAll) {
        this.motionAfterMilliseconds(1000);
      }

      const isSomewhatVisible = this.isInViewport(this.node[0]);

      if (isSomewhatVisible) {
        this.doMotion();
        this.motionDone = true;
      }
    }
  }

  motionAfterMilliseconds(milliseconds) {
    if (!this.visibilityTimeout) {
      this.visibilityTimeout = setTimeout(() => {
        this.motionDone = true;
        this.doMotion();
      }, milliseconds);
    }
  }

  isInViewport(element, percentVisibleOfElementHeight = 0.7) {
    const rectangle = element.getBoundingClientRect();
    const navigationHeight = this.getNavigationHeight();

    const forceMotionAfterPixelsVisible = 300;
    const hasToBeVisiblePercent = Math.min(percentVisibleOfElementHeight, forceMotionAfterPixelsVisible / rectangle.height); // 0-1;

    const visible =
      rectangle.bottom > navigationHeight + rectangle.height * hasToBeVisiblePercent &&
      rectangle.right > rectangle.width * hasToBeVisiblePercent &&
      rectangle.top < (window.innerHeight || document.documentElement.clientHeight) - rectangle.height * hasToBeVisiblePercent &&
      rectangle.left < (window.innerWidth || document.documentElement.clientWidth) - rectangle.width * hasToBeVisiblePercent;

    return visible;
  }

  getNavigationHeight() {
    const navigationNode = $('nav.navigation.nav');

    if (navigationNode.length) {
      return navigationNode.height();
    }

    return 0;
  }
}
